import React from 'react'
import { Fade } from 'react-awesome-reveal'

function About() {

    const handleSubmit = (e) => {
        e.preventDefault()
    }

    return (
        <section className="section-about padding-tb-100">
            <img src="assets/img/effect/line-effect.png" alt="line-effect" className="line-effect" />
            <img src="assets/img/effect/theme-2.png" alt="theme" className="theme-3" />
            <img src="assets/img/effect/theme-4.png" alt="theme" className="theme-4" />
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <Fade triggerOnce duration={2000} direction='up' className="about-us">
                            <>
                                <div className="banner w-100 t-left">
                                    <h2>AI Make Your Device Manage Everything For You.</h2>
                                </div>
                                <p>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex
                                    eligendi, beatae facere dolore cupiditate sapiente nobis? Porro
                                    minima similique placeat aliquid corporis eos laborum
                                    praesentium repellat doloremque, voluptatem tenetur molestiae?
                                </p>
                                <p>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex
                                    eligendi, beatae facere dolore cupiditate sapiente nobis? Porro
                                    minima similique placeat aliquid corporis eos laborum
                                    praesentium repellat doloremque, voluptatem tenetur molestiae?
                                </p>
                            </>
                        </Fade>
                        <Fade triggerOnce duration={2000} direction='up' className="zx-project">
                            <>
                                <div className="row">
                                    <div className="col-6 d-flex">
                                        <h4>30+</h4>
                                        <p><a onClick={handleSubmit} href="/">Million Users</a></p>
                                    </div>
                                    <div className="col-6 d-flex">
                                        <h4>15</h4>
                                        <p><a onClick={handleSubmit} href="/">Award Winning</a></p>
                                    </div>
                                </div>
                            </>
                        </Fade>
                        <Fade triggerOnce duration={2000} direction='up' className="zx-data">
                            <>
                                <p>
                                    <i className="fa-solid fa-arrow-right"></i>
                                    Realtime Best Data Realtime Solutions
                                </p>
                                <p>
                                    <i className="fa-solid fa-arrow-right"></i>
                                    project Intialization Realtime Best Data Solutions
                                </p>
                                <p>
                                    <i className="fa-solid fa-arrow-right"></i>
                                    Realtime Best Data Solutions
                                </p>
                                <p>
                                    <i className="fa-solid fa-arrow-right"></i>
                                    Market Devlopment Realtime Data Solutions
                                </p>
                            </>
                        </Fade>
                    </div>
                    <Fade triggerOnce duration={2000} direction='up' className="col-12 col-lg-6" >
                        <img src="assets/img/home/data-solutions.png" alt="Data-Solutions" className="solutions" />
                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default About
